export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen pt-[72px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium tracking-wide mb-5">
              奇幻 · 魔幻 · 萌系
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              妖精漫画网
              <br />
              <span className="text-primary-600">海量漫画免费追更平台</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              妖精漫画网官方入口，汇聚海量奇幻、魔幻与萌系漫画，支持下拉式全集阅读，持续追更不停歇。
              无论是最新连载还是经典全集，在这里都能安全快速地畅享奇妙漫画世界。
            </p>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              平台当前覆盖百余部热门作品，每日稳定更新，全方位满足不同读者的阅读偏好与追更节奏，
              为您打造沉浸式的漫画在线阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">热门连载</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">稳定更新</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">安全</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">快速访问</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 hover:border-background-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                热门排行
                <i className="ri-fire-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/5] lg:aspect-[5/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20manga%20illustration%20featuring%20a%20group%20of%20diverse%20anime%20characters%20with%20magical%20elements%20floating%20sparkles%20and%20ethereal%20glowing%20orbs%20against%20a%20dreamy%20gradient%20background%20of%20soft%20pink%20and%20golden%20hues%20with%20cherry%20blossom%20petals%20drifting%20across%20the%20scene%20warm%20cinematic%20lighting%20stylized%20Japanese%20manga%20art%20style%20highly%20detailed%20vibrant%20colors%20editorial%20quality&width=800&height=640&seq=hero-manga-main&orientation=landscape"
                alt="妖精漫画网 - 海量奇幻魔幻萌系漫画免费追更"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}